export default __webpack_public_path__ + "static/media/36I-102795_-15933_0.4cbd8ee7.jpg";